import { useTranslation as useI18nTranslation } from 'react-i18next';
import { useCallback } from 'react';

export type Language = 'en' | 'ko';

export function useTranslation(namespace: string = 'navigation') {
  const { t, i18n, ready } = useI18nTranslation(namespace);

  const currentLanguage = i18n.language as Language;

  const changeLanguage = useCallback(async (lng: Language) => {
    await i18n.changeLanguage(lng);
    document.documentElement.lang = lng;
  }, [i18n]);

  return {
    t,
    i18n,
    ready,
    currentLanguage,
    changeLanguage,
  };
}